// Write your Javascript code.
;
Promise.config({
    longStackTraces: true,
    warnings: false
});

$(document).ready(function(){
    $('.input-rating').rating();

    var handleTagManagerEvent = function() {
        var $this = $(this);
        dataLayer.push({
            'event': $this.attr('data-tagmanager-event'),
            'parameter': $this.attr('data-tagmanager-event-param')
        });
    };

    var handleDataTrackCategory = function(e) {
        var $this = $(this);
        var performTrack = false;

        if ( $this.prop('tagName') === 'FORM' ) {
            if ( e.type === 'submit' ) {
                performTrack = true;
            }
        } else {
            if ( e.type === 'click' ) {
                performTrack = true;
            }
        }

        if ( performTrack ) {
            var category = $this.attr('data-track-category');
            var action = $this.attr('data-track-action');
            var label = $this.attr('data-track-label');
            var value = $this.attr('data-track-value');
            var sampleKitId = $this.attr('data-track-samplekit-id');
            if ( (label || {}).length == 0 ) {
                label = location.protocol + '//' + location.host + location.pathname;
            }
            window.snTrackEventsModule.trackEvent(sampleKitId, category, action, label, value);
        }
    };

    $(document).on('submit', 'form[data-track-category]', handleDataTrackCategory);
    $(document).on('click', '[data-track-category]', handleDataTrackCategory);
    $(document).on('click', '[data-tagmanager-event]', handleTagManagerEvent);

    // Hide Facebook like box
    var $fbLikeBox = $('#facebookLikeBox');
    $('.overlay__close', $fbLikeBox).click(function() {
        $fbLikeBox.remove();
        if (typeof(Storage) !== "undefined") {
            window.localStorage.hideFbLikeBox = true;
        }
    });
    if (typeof(Storage) !== "undefined"
        && window.localStorage.hideFbLikeBox ) {
            $fbLikeBox.remove();
    } else {
        $fbLikeBox.removeClass('hide-for-medium-up');
    }

    if ($('[data-timeago]').length > 0) {
        function timeSince(date) {

            var seconds = Math.floor((new Date() - date) / 1000);

            var interval = Math.floor(seconds / 31536000);

            if (interval > 1) {
                return interval + " years";
            }
            interval = Math.floor(seconds / 2592000);
            if (interval > 1) {
                return interval + " months";
            }
            interval = Math.floor(seconds / 86400);
            if (interval > 1) {
                return interval + " days";
            }
            interval = Math.floor(seconds / 3600);
            if (interval > 1) {
                return interval + " hours";
            }
            interval = Math.floor(seconds / 60);
            if (interval > 1) {
                return interval + " minutes";
            }
            return Math.floor(seconds) + " seconds";
        }

        function updateTimeago() {
            var seconds = false;
            $('[data-timeago]').each(function(idx,el){
                el.innerText = timeSince(new Date($(el).attr('datetime'))) + ' ago';
                if ( el.innerText.indexOf('seconds') > 0 ) {
                    seconds = true;
                }
            });
            setTimeout(updateTimeago, seconds ? 250 : 30000);
        }
        updateTimeago();
    }

    $('.menu-icon').click(function(e){
        e.preventDefault();

        var $topbar = $(".top-bar");
        var expand = !($topbar.hasClass('expanded'));
        if ( expand ) {
            $topbar.addClass('expanded');
        } else {
            $topbar.removeClass('expanded');
        }
    });
});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function saveProductReferral(sampleKitId) {
    if (getParameterByName('user_referrer') && getParameterByName('user_referral_channel') ) {
        $.ajax({
            url : window.site.urls.api + '/productreferrals',
            type: "POST",
            data: JSON.stringify({
                referrer: getParameterByName('user_referrer'),
                channel: getParameterByName('user_referral_channel'),
                product: sampleKitId
            }),
            contentType: "application/json; charset=utf-8",
            dataType   : "json",
            success    : function(){
                //console.log("Pure jQuery Pure JS object");
            }
        });
    }
}